<template>
  <div class="step-actions">
    <span
      class="step-actions__timer"
      :class="{
        'step-actions__timer--invisible': hideActions || step === totalSteps,
      }"
    >
      <template v-if="minutes < 10">0</template>{{ minutes }}
      :
      <template v-if="seconds < 10">0</template>{{ seconds }}
    </span>
    <div
      class="step-actions__buttons"
      :class="{
        'step-actions__buttons--invisible': hideActions || step === totalSteps,
      }"
    >
      <button
        class="
          button button--back button--arrow button--arrow-back button--shadow
        "
        :class="{ 'button--invisible': hideReturn || step === totalSteps }"
        @click="prevStepHandler"
      >
        cofnij
      </button>
      <button
        class="button button--alter button--arrow button--shadow"
        :class="{
          'button--disabled button--disabled-alter button--alter-step-change':
            !isStepValid || isSending,
          'button--invisible': step === totalSteps,
        }"
        ref="nextStep"
        @click="nextStepHandler"
        @mouseenter="nextStepHover"
      >
        <template v-if="isSending"> wysyłam </template>
        <template v-else-if="step >= totalSteps - 1"> wyślij </template>
        <template v-else> dalej </template>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StepActions',
  props: {
    isWelcome: {
      type: Boolean,
      required: true,
    },
    isStepValid: {
      type: Boolean,
      required: true,
    },
    isSending: {
      type: Boolean,
      required: true,
    },
    step: {
      type: Number,
      required: true,
    },
    totalSteps: {
      type: Number,
      required: true,
    },
    noReturnSteps: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    interval: null,
    date: null,
    minutes: 0,
    seconds: 0,
    intervals: {
      second: 1000,
      minute: 1000 * 60,
    },
    isTransitioning: false,
  }),
  computed: {
    hideActions() {
      return this.isWelcome;
    },
    hideReturn() {
      return this.noReturnSteps.includes(this.step) || this.isWelcome;
    },
  },
  watch: {
    isWelcome() {
      if (!this.isWelcome) {
        this.startCounting();
      } else {
        this.stopCounting();
      }
    },
  },
  methods: {
    nextStepHover() {
      this.hideTooltip();
    },
    hideTooltip() {
      if (this.isStepValid || this.step >= this.totalSteps - 1) {
        UIkit.tooltip(this.$refs.nextStep).hide();
      }
    },
    prevStepHandler() {
      if (this.isTransitioning || this.isSending) {
        return;
      }

      this.isTransitioning = true;

      this.$emit('reduce-step');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);

      setTimeout(() => {
        this.isTransitioning = false;
      }, 900);
    },
    async nextStepHandler() {
      if (this.isTransitioning || this.isSending) {
        return;
      }

      if (this.step === this.totalSteps - 1 && this.isStepValid) {
        this.$emit('send-form');

        return;
      }

      if (this.isStepValid) {
        this.isTransitioning = true;

        setTimeout(() => {
          this.$refs.nextStep.classList.remove('button--alter-step-change');
        }, 350);
        this.$emit('increment-step');
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);

        setTimeout(() => {
          this.isTransitioning = false;
        }, 900);
      }
    },
    startCounting() {
      this.date = new Date();
      this.interval = setInterval(() => {
        this.updateDiffs();
      }, 1000);
      this.updateDiffs();
    },
    stopCounting() {
      clearInterval(this.interval);
    },
    updateDiffs() {
      let diff = Math.abs(Date.now() - this.date.getTime());
      this.minutes = Math.floor(diff / this.intervals.minute);
      diff -= this.minutes * this.intervals.minute;
      this.seconds = Math.floor(diff / this.intervals.second);
      this.$emit('time-elapsed', {
        seconds: this.seconds,
        minutes: this.minutes,
      });
    },
  },
  mounted() {
    UIkit.tooltip(this.$refs.nextStep, {
      title: 'Uzupełnij poprawnie wszystkie wymagane pola',
      delay: 300,
      duration: 200,
      pos: 'top-right',
      animation:
        'uk-animation-slide-top-small, uk-animation-slide-top-medium uk-animation-reverse',
    });
  },
  updated() {
    this.hideTooltip();
  },
  destroyed() {
    this.stopCounting();
  },
};
</script>
<style scoped lang="scss">
/* prettier-ignore */
.step-actions {
  &__timer {
    display: block;
    color: #999;
    font-size: 0.813rem;
    font-weight: 500;
    padding: rem(12px 10px 12px 12px);
    border-radius: 0.313rem;
    border: 0.063rem solid #e7e7e7;
    position: fixed;
    top: rem(28px);
    left: 2.25rem;
    min-width: rem(68px);
    transition: $t-opacity, $t-transform;

    @include media-min($sm) {
      left: 50%;
      transform: translateX(-50%);
    }

    @include media-min($lg) {
      bottom: rem(100px);
      left: rem(100px);
      min-width: rem(95px);
      padding: rem(20px 24px 20px 26px);
      transform: unset;
      top: unset;
    }

    &--invisible {
      opacity: 0;
      transform: translateY(rem(-100px));

      @include media-min($sm) {
        transform: translate(-50%, rem(-100px));
      }

      @include media-min($lg) {
        transform: translate(0, -120%);
      }
    }
  }

  &__buttons {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 100%;
    padding: rem(20px) 2.25rem;
    display: flex;
    justify-content: space-between;
    transition: $t-opacity, $t-transform;

    @include media-min($sm) {
      padding: rem(20px) 30px;
    }

    @include media-min($md) {
      padding: rem(20px) 40px;
    }

    @include media-min($lg) {
      width: auto;
      padding: 0;
      bottom: rem(100px);
      right: rem(168px);
    }

    &::before {
      content: "";
      display: block;
      position: absolute;
      height: 120%;
      width: 100%;
      bottom: 0;
      left: 0;
      background: {
        image: linear-gradient(0deg, rgba(242, 242, 242, 0.7) 0%, rgba(242, 242, 242, 0.7) 70%, rgba(255, 255, 255, 0) 100%);
      };
    }

    &--invisible {
      opacity: 0;
      transform: translateY(120%);
    }

    .button {
      &:hover {
        //@include media-max($lg) {
        //color: $white;
        //background-position: 99% center;
        //}

        &::after {
          background-position: center;
        }
      }

      &:first-child {
        @include media-min($lg) {
          margin-right: rem(20px);
        }
      }

      &--back {
        background: $purple;
        background: linear-gradient(90deg, $purple 0%, $purple 50%, $white 50%, $white 100%);
        background-size: 204% auto;
        background-position: left center;

        &:hover {
          color: #000;
          background-position: right center;
        }
      }

      &--alter {
        background: linear-gradient(270deg, #e9e9e9 0%, #e9e9e9 33.333%, $purple 33.33%, $purple 66.6666%, $white 66.666%, $white 100%);
        background-size: 304% auto;
        background-position: center center;

        &:hover {
          color: #000 !important;
          background-position: left center;
        }
      }

      &--disabled-alter {
        pointer-events: initial;
        background-position: right center;

        &:hover {
          color: #000 !important;
          background-position: right center;
          cursor: initial;

          &::after {
            background-position: center center !important;
          }
        }
      }

      &--alter-step-change {
        background: linear-gradient(270deg, #e9e9e9 0%, #e9e9e9 66.666%, $white 66.666%, $white 100%);
        background-size: 304% auto;
        background-position: right center;
      }
    }
  }
}
</style>
